import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

// 分类

export const QueryCategoryTree = () => {
    return api.get(`/wf/category/getWfCategoryTree`);
};

export const AddCategory = data => {
    return api.post(`/wf/category/addWfCategory`, data);
};

export const UpdateCategory = data => {
    return api.post(`/wf/category/updateWfCategory`, data);
};

export const DeleteCategory = ({ id }) => {
    return api.delete(`/wf/category/deleteWfCategory/${id}`);
};

export const QueryFlowableModel = data => {
    return api.post(``, data);
};

export const AddFlowableModel = data => {
    return api.post(``, data);
};

export const UpdateFlowableModel = data => {
    return api.post(``, data);
};

export const DeleteFlowableModel = ({ id }) => {
    return api.delete(`${id}`);
};

export const QueryFlowableModelList = () => {
    return api.post(``);
};

export const SaveModelFlowable = data => {
    return api.post(``, data);
};
